import { useState } from 'react';
import styles from './Section03.module.css';

function Section03() {
    const [activeImage, setActiveImage] = useState(1);

    const sections = [
        {
            id: 1,
            title: '01 색채 컨설팅',
            items: [
                '환경, 제품, 그래픽 부터 등 다양한 영역의 기업 업의 범위와 방향성',
                '퍼스널컬러, 컬러테라피, 이미지컨설팅 등 개인 브랜딩 컨설팅'
            ],
            image: '/image/section03-01.png' // 실제 이미지 경로로 변경
        },
        {
            id: 2,
            title: '02 기업 및 기관 교육',
            items: [
                '직무능력향상과 직원 경쟁력 강화를 위한 워크숍, 특강, 전문교육 진행',
                '디자인, 브랜드, 컬러테라피, 향업, 4계절분석 등 기업맞춤 교육 제안'
            ],
            image: '/image/section03-02.png'
        },
        {
            id: 3,
            title: '03 아카데미',
            items: [
                '강사양성학원 외, 퍼스널컬러 컨설턴트, 컬러테라피, 컬러서비스, 컬러테라피아 전문가 등 새시 분야 전문가 양성을 위한 자격과정 및 수료과정 운영'
            ],
            image: '/image/section03-03.png'
        }
    ];

    return (
        <div className={styles.section03}>
            <div className={styles.container}>
                <h2 className={styles.mainTitle}>Business Overview</h2>
                <p className={styles.subtitle}>
                    한국실상색채컴퍼니는 개인과 단체의 브랜드 경쟁력을 높이는<br />
                    색채 컨설팅 및 교육을 진행하고 있습니다.
                </p>

                <div className={styles.content}>
                    <div className={styles.textSection}>
                        {sections.map((section) => (
                            <div
                                key={section.id}
                                className={`${styles.textItem} ${activeImage === section.id ? styles.active : ''}`}
                                onMouseEnter={() => setActiveImage(section.id)}
                                onClick={() => setActiveImage(section.id)}
                            >
                                <h3 className={styles.title}>{section.title}</h3>
                                <ul className={styles.list}>
                                    {section.items.map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>

                    <div className={styles.imageSection}>
                        {sections.map((section) => (
                            <img
                                key={section.id}
                                src={section.image}
                                alt={section.title}
                                className={`${styles.image} ${activeImage === section.id ? styles.imageActive : ''}`}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Section03;